"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useButtons = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
var _presentationHttp = require("@ori/presentation-http");
var _tsUtils = require("@ori/ts-utils");
var _react = require("react");
var _hooks = require("../../hooks");
// import { logDebug } from '../../logger';
const useButtons = (props)=>{
    const { formatMessage } = (0, _hooks.useTranslations)();
    const { customerCategory, loading } = (0, _presentationHttp.useUserSegmentationData)();
    const { addBackorderDemand, backorderDemandStatus, canBeDeleted, canBeNotified, canBeReplaced, canDelayBackorder, combineChoiceId, isAvailable, isBackorderAllowed, isBackorderExplicit, isPersonalSubscriptionAvailable, isSubscription, itemDescription, itemType, onCancelBackorderDemand, onDelayBackorder, onSubscribeClick, removeItemHandler, showOnSite, showNotificationDialog, showReplacementDialog, subscription } = props;
    const canBeSubscribedTo = itemType !== 'a' && ((0, _tsUtils.isNonNullable)(subscription) || isPersonalSubscriptionAvailable) && isAvailable && customerCategory !== _globalApiClientReact.GlobalCustomersCustomerTypeDtoCustomerCategory.Employee && !loading;
    const isCombineChoice = typeof combineChoiceId === 'number';
    const isBackorderActive = backorderDemandStatus === 2;
    const canBeReducedNoCombineChoice = canBeDeleted && !isCombineChoice;
    // logDebug(
    //   `🔸Buttons deciding factors:
    //   \r\n - canBeSubscribedTo: ${canBeSubscribedTo}
    //   \r\n - canBeNotified: ${canBeNotified}
    //   \r\n - isBackorderAllowed: ${isBackorderAllowed}
    //   \r\n - isBackorderExplicit: ${isBackorderExplicit}
    //   \r\n - isCombineChoice: ${isCombineChoice}
    //   \r\n - isBackorderActive: ${isBackorderActive}
    //   \r\n - canBeReducedNoCombineChoice: ${canBeReducedNoCombineChoice}
    //   \r\n - canBeReplaced: ${canBeReplaced}
    //   \r\n - isSubscription: ${isSubscription}
    //   `,
    // );
    const buttons = (0, _react.useMemo)(()=>{
        const buttonBuilder = {};
        if (canBeReducedNoCombineChoice) {
            buttonBuilder.remove = {
                text: formatMessage('delete'),
                title: "".concat(formatMessage('delete'), " ").concat(itemDescription),
                visible: true,
                onClick: removeItemHandler
            };
        }
        // favorites is always visible for products that have ShowOnSite flag set to true
        if (showOnSite) {
            buttonBuilder.favorites = {
                text: formatMessage('favorites'),
                title: "".concat(formatMessage('favorites'), " ").concat(itemDescription),
                visible: true
            };
        }
        if (canBeNotified) {
            buttonBuilder.notifyMe = {
                text: formatMessage('notifyMe'),
                title: "".concat(formatMessage('notifyMe'), " ").concat(itemDescription),
                visible: true,
                onClick: showNotificationDialog
            };
        }
        if (canBeReplaced) {
            buttonBuilder.replace = {
                text: formatMessage('replace'),
                title: "".concat(formatMessage('replace'), " ").concat(itemDescription),
                visible: true,
                onClick: showReplacementDialog
            };
        }
        // This part will show button without action and with reserved text shown on subscriptions
        if (isSubscription && isBackorderAllowed) {
            buttonBuilder.reserve = {
                text: formatMessage('reserved'),
                title: "".concat(itemDescription, " - ").concat(formatMessage('reserved')),
                visible: true,
                disabled: true
            };
        }
        // regular reserve button
        if (isBackorderAllowed && !isBackorderActive && Boolean(isBackorderExplicit) && !isSubscription) {
            buttonBuilder.reserve = {
                text: formatMessage('reserve'),
                title: "".concat(formatMessage('reserve'), " ").concat(itemDescription),
                visible: true,
                onClick: addBackorderDemand
            };
        }
        // automated reserved indicator
        if (isBackorderAllowed && !isBackorderExplicit && !isSubscription) {
            buttonBuilder.reserve = {
                text: formatMessage('reserved'),
                title: "".concat(itemDescription, " - ").concat(formatMessage('reserved')),
                visible: true,
                disabled: true
            };
        }
        if (isBackorderActive && Boolean(isBackorderExplicit)) {
            buttonBuilder.unreserve = {
                text: formatMessage('unreserve'),
                title: "".concat(formatMessage('unreserve'), " ").concat(itemDescription),
                visible: true,
                onClick: onCancelBackorderDemand
            };
        }
        if (!isBackorderActive && canDelayBackorder) {
            buttonBuilder.delayBackorder = {
                text: formatMessage('postpone'),
                title: "".concat(formatMessage('postpone'), " ").concat(itemDescription),
                visible: true,
                onClick: onDelayBackorder
            };
        }
        if (canBeSubscribedTo) {
            buttonBuilder.subscribe = {
                text: formatMessage('subscribe'),
                title: "".concat(formatMessage('subscribe'), " ").concat(itemDescription),
                visible: true,
                onClick: onSubscribeClick
            };
        }
        return buttonBuilder;
    }, [
        addBackorderDemand,
        canBeNotified,
        canBeReducedNoCombineChoice,
        canBeReplaced,
        canBeSubscribedTo,
        canDelayBackorder,
        formatMessage,
        isBackorderActive,
        isBackorderAllowed,
        isBackorderExplicit,
        isSubscription,
        itemDescription,
        onCancelBackorderDemand,
        onDelayBackorder,
        onSubscribeClick,
        removeItemHandler,
        showOnSite,
        showNotificationDialog,
        showReplacementDialog
    ]);
    return buttons;
};
exports.useButtons = useButtons;
